<template>
	<section class="detail-panel-item">
		<div class="detail-panel-item__label">{{ label }}</div>
		<div class="detail-panel-item__value">{{ value }}</div>
	</section>
</template>

<script>
export default {
	name: 'detail-panel-item',
	props: {
		label: {
			type: String
		},
		value: {
			type: String|Number
		}
	}
}
</script>

<style>
.detail-panel-item {
	padding: 7px 0;
	margin: 0 0 15px 0;
	width: 100%;
	max-width: 512px;
}
.detail-panel-item__label {
	font-size: 12px;
	padding: 0 15px;
	color: rgba(0, 162, 172, 0.5);
}
.detail-panel-item__value {
	padding: 0 15px 7px 15px;
	border: 1px solid rgba(0, 162, 172, 0.5);
	border-style: none none solid solid;
	border-radius: 0 0 0 3px;
	height: 27px;
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/DetailPanelItem.vue